import { Box, Paper, Grid, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { CARD_CAPTION_STYLE, STYLED_SECTION_TITLE_STYLE } from '../../constants/Styles';


const StyledSection = ({
    children,
    title,
    rightAdornment,
    image,
    paperStyling = {},
    titleStyling = {}
  }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
<Box>
  <Grid container spacing={1}>
    <Grid item xs={12}>
      <Paper
        variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '30px',
          overflow: 'hidden',
          padding: '16px',
          ...paperStyling,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            width: (image && !isMobile) ? '66.66%' : '100%',
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 1,
              marginBottom: 2,
            }}
          >
            <div style={{ ...STYLED_SECTION_TITLE_STYLE, ...titleStyling }}>{title}</div>
            {rightAdornment && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {rightAdornment}
              </Box>
            )}
          </Box>

          {(image && isMobile) && (

            <Box
              component="img"
              src={image}
              alt="Section Visual"
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'cover',
                borderRadius: '8px',
                border: '1px solid #ccc',
                boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
              }}
            />
        )}

          {children}
        </Box>

        {/* Right Image */}
        {(image && !isMobile) && (
          <Box
            sx={{
              width: '33.33%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 1,
              boxSizing: 'border-box',
            }}
          >
            <Box
              component="img"
              src={image}
              alt="Section Visual"
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'cover',
                borderRadius: '8px',
                border: '1px solid #ccc',
                boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
              }}
            />
          </Box>
        )}
      </Paper>
    </Grid>
  </Grid>
</Box>
   
)}

export default StyledSection;